import { lazy } from 'react'

import DocumentTextIcon from '@heroicons/react/outline/esm/DocumentTextIcon.js'

import { I18nShape } from '@tribeplatform/react-components/i18n'

import { BlockType, RegisteredBlock } from '../../types/index.js'
import { RichTextBlock as Component } from './Block.js'
import { RichTextBlockProps } from './types.js'

const Settings = lazy(() =>
  import('./Settings.js').then(m => ({ default: m.RichTextBlockSettings })),
)

export const RegisteredRichTextBlock = (
  intl: I18nShape,
): RegisteredBlock<RichTextBlockProps> => {
  const { $t } = intl

  return {
    recommendedName: 'RichText',
    Component,
    config: {
      type: BlockType.Block,
      usable: true,

      displayName: $t({
        id: 'Blocks.RichText.DisplayName',
        defaultMessage: 'Rich Text',
      }),
      Settings,
      Icon: <DocumentTextIcon />,
      defaultProps: {
        textColor: 'dark',
        content: '',
      },
    },
  }
}
